// CustomerTrackingPage.jsx
import React, { useState, useEffect } from 'react';
import LiveRouteMap from './LiveRouteMap';
import 'leaflet/dist/leaflet.css';

const CustomerTrackingPage = () => {
  const [routeData, setRouteData] = useState(null);
  const [customerName, setCustomerName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const routeKey = urlParams.get('route');

    if (routeKey) {
      const formattedKey = routeKey.replace(/%20/g, '_');
      const storedData = localStorage.getItem(formattedKey);

      if (storedData) {
        try {
          const data = JSON.parse(storedData);
          setRouteData(data.routeData);
          setCustomerName(data.routeData.customer);
        } catch (err) {
          setError("Invalid tracking data.");
        }
      } else {
        // Debug: Check all localStorage keys
        console.log("Available localStorage keys:", Object.keys(localStorage));
        setError("Invalid or expired tracking link. Key not found in localStorage.");
      }
    } else {
      setError("No tracking link provided.");
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '20px' }}>Loading...</div>;
  }

  if (error) {
    return <div style={{ textAlign: 'center', padding: '20px', color: 'red' }}>{error}</div>;
  }

  if (!routeData) {
    return <div style={{ textAlign: 'center', padding: '20px' }}>No route data found.</div>;
  }

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto', height: '90vh' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>📦 Live Tracking for {customerName}</h2>
      <div style={{ height: '80vh', width: '100%' }}>
        <LiveRouteMap routes={[routeData]} isCustomerView={true} />
      </div>
    </div>
  );
};

export default CustomerTrackingPage;
